import { LoggedApiConnector } from 'Connectors/LoggedApiConnector';
import ConfigProxy            from 'tools/ConfigProxy';
import PartitionApiModel      from './PartitionApiModel';

export const partitionLoggedApiConnector = new LoggedApiConnector({
	baseURL: ConfigProxy.getServiceConfig('partition', 'api_endpoint'),
});

export default class PartitionPrivateApiModel extends PartitionApiModel {
	public static get connector() {
		return partitionLoggedApiConnector;
	}
}
